import { OptionProps, components } from 'react-select';
import { Checkbox } from 'ui/checkboxV2';
import {
  SelectOptionValue,
  SelectOptionInnerWrapper,
  SecondaryText,
  LabelWithoutCheckbox,
  Description,
} from './Select.styles';
import { BaseOption, NewBaseOption } from './types';

export const MultiSelectInputOption = ({
  isSelected,
  isDisabled,
  children,
  data,
  ...props
}: OptionProps<BaseOption | NewBaseOption>) => {
  if (data.selectAllCategory) {
    return (
      <components.Option
        className="select-all"
        {...props}
        data={data}
        isDisabled={isDisabled}
        isSelected={isSelected}
      >
        {children}
      </components.Option>
    );
  }

  const isNewCreateOption = '__isNew__' in data && data.__isNew__ === true;

  return (
    <components.Option {...props} data={data} isDisabled={isDisabled} isSelected={isSelected}>
      <SelectOptionValue data-test={`multiselect-option-${data?.value}`}>
        <SelectOptionInnerWrapper>
          {isNewCreateOption ? (
            <LabelWithoutCheckbox>{children}</LabelWithoutCheckbox>
          ) : (
            <Checkbox isDisabled={isDisabled} status={isSelected} label={children} />
          )}
          {data.Suffix ? <SecondaryText>{data.Suffix}</SecondaryText> : null}
        </SelectOptionInnerWrapper>
        {data.description && <Description data-multi={true}>{data.description}</Description>}
      </SelectOptionValue>
    </components.Option>
  );
};
